import { MessagesYup } from 'src/modules/messages'
import * as yup from 'yup'

export const schema = yup.object().shape({
  dataCarregamento: yup.date().typeError(MessagesYup.MENSAGEM_DATA_INVALIDA),
  dataDescarregamento: yup.date().typeError(MessagesYup.MENSAGEM_DATA_INVALIDA)
})
